import InfiniteScroll from 'infinite-scroll';

if (document.querySelectorAll('.infinite-articles').length) {
  // Always use the "next" link the server rendered, both on the initial page and
  // in every fetched page. Computing the offset client-side broke on pages that
  // render each item more than once (e.g. the event calendar's list + map views).
  let nextHref = document.querySelector('.nextlink')?.getAttribute('href');

  const hideButtons = () => {
    document.querySelectorAll('.nextlink').forEach((nextLink) => {
      nextLink.style.display = 'none';
    });
  };

  const infiniteScroll = new InfiniteScroll('.infinite-articles', {
    // Returning a falsy value tells the library the last page was reached.
    path() {
      return nextHref;
    },
    append: '.infinite-articles .infinite-article',
    history: false,
    loadOnScroll: false,
    button: '.nextlink',
  });

  // Note: events are plain names ('load', 'last'); the '.infiniteScroll' suffix
  // only applies to jQuery-triggered events, which this project does not use.
  infiniteScroll.on('load', (body) => {
    nextHref = body.querySelector('.nextlink')?.getAttribute('href');
    if (!nextHref) {
      hideButtons();
    }
  });

  infiniteScroll.on('last', hideButtons);
}
